import {ListGroup, Placeholder, Stack} from "react-bootstrap";
import React from "react";

export function ItemLoading({show}) {
    return <>
        {show && <Placeholder as={ListGroup.Item} animation="wave" className="mb-1 py-0 py-sm-1 px-1 px-sm-2 rounded border-0">
            <Stack direction="horizontal" className="justify-content-between" gap="2">
                <Placeholder.Button variant="secondary" xs={1}/>
                <Stack className="ps-2 justify-content-around">
                    <Placeholder xs={4}/>
                    <span></span>
                    <Placeholder xs={2}/>
                </Stack>
            </Stack>
        </Placeholder>
        }</>
}

export function TagsLoading({show}) {
    return <>
        {show && <Placeholder as={ListGroup.Item} animation="wave" className="mb-1 py-0 py-sm-1 px-1 px-sm-2 rounded border-0">
            <Stack direction="horizontal" className="justify-content-between" gap="2">
                <Stack className="ps-2 justify-content-around">
                    <Placeholder xs={2} className="rounded"/>
                    <span></span>
                    <Placeholder xs={4}/>
                </Stack>
            </Stack>
        </Placeholder>
        }
    </>
}
export function ProductCardLoading({show}) {
    return <>
        {show && <Placeholder as={ListGroup.Item} animation="wave" className="my-2 rounded border-0">
            <Stack direction="horizontal" className="justify-content-between">
                <Stack className="ps-2 justify-content-around" gap="1">
                    <Placeholder.Button variant="secondary" xs={3}  />
                    <Placeholder xs={3} className="rounded"/>
                    <Placeholder  animation="wave">
                        <Placeholder xs={2} /> <Placeholder xs={1} />
                    </Placeholder>
                </Stack>
            </Stack>
        </Placeholder>
        }
    </>
}

export function EditUserLoading({show}) {
    return <>
        {show && (
            <Placeholder as={ListGroup.Item} animation="wave" className="mb-1 py-0 py-sm-1 px-1 px-sm-2 rounded border-0">
                <Stack direction="horizontal" className="justify-content-between align-items-center ps-2">
                    <Stack>
                        <Placeholder xs={2}/>
                        <Placeholder xs={4}/>
                    </Stack>
                    <Placeholder.Button variant="secondary" xs={2} className="d-none d-sm-inline"/>
                </Stack>
            </Placeholder>
        )}
    </>
}

